<template>
  <main>
    <div>
      <v-container>
        <v-card class="">
          <div class="card-content">
            <img src="/static/svg/communication/chat-1.svg" style="height: 40px;">
            <span class="card-title" style="vertical-align:top;">
              サークル概要
            </span>
            <p>
              ほげ.class は2014年に、マインクラフトサーバMODである「CraftBukkit」の本を書くための、
              個人（同人）サークルとして誕生しました。
              その後、コミックマーケットをはじめ、超会議、マインクラフトオンリーといったイベントに参加する過程で、
              多くのマインクラフトファンや、教育、メディア関係の方々にお会いし、個人活動に留めるにはもったいないと感じました。
            </p>
            <hr>
            <img src="/static/svg/communication/newspaper.svg" style="height: 40px;">
            <span class="card-title" style="vertical-align:top;">
              なぜ同人誌？
            </span>
            <p>
              同人誌執筆のきっかけは、ニコニコ生放送のユーザ配信で行われていたマインクラフトイベントでした。<br>
              もちろん、それらはサーバMODを使用して建てられたマルチプレイ用サーバで行われていました。
              (サーバMODに分類される拡張サーバでは、有志が開発したプラグインを組み合わせることで
              一定時間透明になったり、ワープしたりと、様々なアクションを起こすことができます)<br>
              あるとき、いつも見ていた生放送の配信者が言いました。<br>
              「自分でもプラグインが作れたら、もっと面白くできるのに。」<br>
              私を含めて、少数の配信者は自分でプラグインを開発して、オリジナルの遊びを行っていましたが、
              多くの人たちはそうではありませんでした。<br>
              そこで、私は考えました。<br>
              <br>
              「Webの情報だけだとわからない人がいる。本など、紙媒体のほうが向いている人がいるのではないか。」
              <br><br>
              その考えのもとに、2014年初の同人誌を執筆しました。この本は、超会議内で、声をかけてくれた人に
              プレゼントするという無償のものでした。<br>
              そして、受け取った方々から良い反響をいただき、作成してよかったと感じました。
              もちろん、何人かの方々は、これをきっかけにプラグインの開発を始めました。
              <br><br>
              このような経験をして、もっと多くの方々の手にこのようなマインクラフト同人誌が渡れば、
              マインクラフトを盛り上げれるのではないか、と考えるようになりました。
              <br><br>
              マインクラフトを盛り上げたい。その目標を達成するために、私は同人誌を書いています。
            </p>
          </div>
        </v-card>
      </v-container>
    </div>
  </main>
</template>

<script>
export default {
  name: 'overview',
  head: {
    title: {
      inner: 'サークル概要'
    }
  }
}
</script>


// WEBPACK FOOTER //
// Overview.vue?ceb188a0